export default "__VITE_ASSET__CdeyfJrR__"